<template>
    <div style="width:100%; box-sizing: border-box; text-align: left;">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>
    <GrcDialogPayment_SimpleV2 ref="DialogPayment"
        v-on:popupopened="SetPopupRef('DialogPayment')"
        v-on:popupclosed="SetPopupRef('')"
    ></GrcDialogPayment_SimpleV2>
    <CalcPopup
        ref="CalcPopup"
        v-on:setvalue="Calc_SetValue"
    />





        <div style="width:100%; box-sizing:border-box; margin:10px 0px 0px 0px; display:block;" v-show="formid==1">
            <div style="width:100%; box-sizing:border-box; display:inline-block; text-align:center; font-weight:500; margin-bottom:26px; font-size:22px; line-height:22px; color:var(--themecolor3);">
                <i class="fal fa-user-lock" style="margin-right:10px;"></i>Azonosítás
            </div>

            <GrcNum ref="txtTagkod" v-model="txtTagkod" 
            grc_labeltext="Tagkód:"
            grc_placeholder="..."
            grc_currency="" grc_decimalplaces="0" grc_readonly="false"
            grc_textalign="left"
            grc_labelmode="" grc_labelwidth="200px" 
            v-on:grc-keydown-enter="SetControlToFocus('txtJelszo');"
            style="margin-bottom:20px;"
            />

            <GrcText ref="txtJelszo" v-model="txtJelszo" 
            grc_ispassword="true"
            grc_labeltext="Portál jelszó:"
            grc_placeholder="..."
            grc_labelmode="" grc_labelwidth="100px" 
            v-on:grc-keydown-enter="SetControlToFocus('');"
            style="margin-bottom:21px;"
            grc_canshowpassword="mobilapp"
            />


            <div style="width:100%; box-sizing:border-box; text-align:center;">

                <span class="cms_linkbutton cms_linkbutton_2" style="margin: 4px 8px;" @click="Azonositas(1)">
                    <span>Tovább<i class="fal fa-angle-double-right" style="margin-left:10px;"></i></span>
                </span>

                <div style="width:100%; box-sizing:border-box; display:inline-block; text-align:center; font-weight:500;
                margin:10px 0px; font-size:16px; line-height:16px; color:#000;">- vagy -</div>


                <span class="cms_linkbutton cms_linkbutton_BLUE" style="margin: 4px 8px;" @click="GoToForm(2)">
                    <span><i class="fal fa-user" style="margin-right:10px;"></i>Személyes adatokkal</span>
                </span>

            </div>   

        </div>


        <div style="width:100%; box-sizing:border-box; margin:10px 0px 0px 0px; display:block;" v-show="formid==2">
            <div style="width:100%; box-sizing:border-box; display:inline-block; text-align:center; font-weight:500; margin-bottom:26px; font-size:22px; line-height:22px; color:var(--themecolor3);">
                <i class="fal fa-user-lock" style="margin-right:10px;"></i>Azonosítás
            </div>


            <div style="width:50%; box-sizing:border-box; display:inline-block; vertical-align:top; padding-right:10px;">
                <GrcNum ref="txtTagkodSzemelyes" v-model="txtTagkodSzemelyes" 
                grc_labeltext="Tagkód:"
                grc_placeholder="..."
                grc_currency="" grc_decimalplaces="0" grc_readonly="false"
                grc_textalign="left"
                grc_labelmode="" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('txtSzulDatum');"
                style="margin-bottom:20px;"
                />
            </div>
            <div style="width:50%; box-sizing:border-box; display:inline-block; vertical-align:top; padding-left:10px;">
                <GrcDate ref="txtSzulDatum" v-model="txtSzulDatum" grc_dateformat="ymd" grc_sep="." 
                grc_labeltext="Születési idő:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                v-on:grc-keydown-enter="SetControlToFocus('txtNev');"
                style="margin-bottom:20px;"
                />
            </div>

            <GrcText ref="txtNev"
            grc_ispassword="false"
            grc_labeltext="Vezeték és keresztnév:"
            grc_placeholder="..."
            grc_labelmode="" grc_labelwidth="200px" 
            v-on:grc-keydown-enter="SetControlToFocus('');"
            style="margin-bottom:20px;"
            grc_canshowpassword="mobilapp"
            />

            <input type="text" style="width:100%; display:block; border:none; font-size:1px; line-height:1px; opacity:0; margin:0px; padding:0px;">

            <div style="width:100%; box-sizing:border-box; text-align:center;">

                <span class="cms_linkbutton cms_linkbutton_2" style="margin: 4px 8px;" @click="Azonositas(2)">
                    <span>Tovább<i class="fal fa-angle-double-right" style="margin-left:10px;"></i></span>
                </span>

                <div style="width:100%; box-sizing:border-box; display:inline-block; text-align:center; font-weight:500;
                margin:10px 0px; font-size:16px; line-height:16px; color:#000;">- vagy -</div>


                <span class="cms_linkbutton cms_linkbutton_BLUE" style="margin: 4px 8px;" @click="GoToForm(1)">
                    <span><i class="fal fa-user" style="margin-right:10px;"></i>Portál bejelentkezés</span>
                </span>

            </div>   


        </div>




        <div style="width:100%; box-sizing:border-box; margin:10px 0px 0px 0px; display:block;" v-show="formid==3">

            <div style="width:100%; box-sizing:border-box; display:inline-block; text-align:center; font-weight:500; margin-bottom:26px; font-size:22px; line-height:22px; color:var(--themecolor3);">
                <i class="fal fa-credit-card-front" style="margin-right:10px;"></i>Bankkártyás befizetés
            </div>

            <GrcCombo ref="cboTipus" v-model="TipusID" grc_labeltext="Befizetés típusa:"
            grc_labelmode="above" grc_labelwidth="200px" grc_dropdownminwidth="300"  
            grc_keyfield="id" grc_displayfield="Megnevezes"
            v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'false'}]"
            v-on:dropdownopened="SetPopupRef('cboTipus')"
            v-on:dropdownclosed="SetPopupRef('')"
            style="margin-bottom:20px;"
            />

            <div style="width:100%; box-sizing:border-box;">
                <div style="width:180px; box-sizing:border-box; display:inline-block; vertical-align:top;">
                    <GrcNum ref="txtOsszeg" v-model="txtOsszeg" 
                    grc_labeltext="Összeg:"
                    grc_placeholder="..."
                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                    grc_textalign="left"
                    grc_labelmode="" grc_labelwidth="200px" 
                    v-on:grc-keydown-enter="SetControlToFocus('txtEmailCim');"
                    style="margin-bottom:20px; max-width:180px;"
                    />
                </div>
                <div style="width:calc(100% - 180px); box-sizing:border-box; display:inline-block; vertical-align:top; padding-top:22px;">
                    <span
                        class="cms_linkbutton cms_linkbutton_BLUE"
                        style="margin-left:10px; font-size: 19px; padding: 10px 12px 10px 12px;"
                        @click="Calc_Show"
                        title="Kalkulátor"
                    >
                        <span>
                            <i class="fal fa-calculator"></i>
                        </span>
                    </span>

                </div>
            </div>


            <GrcText ref="txtEmailCim"
            grc_ispassword="false"
            grc_labeltext="E-mail cím:"
            grc_placeholder="..."
            grc_labelmode="" grc_labelwidth="200px" 
            v-on:grc-keydown-enter="SetControlToFocus('');"
            style="margin-bottom:20px;"
            grc_canshowpassword="mobilapp"
            />


            <table style="width:100%; margin-bottom:30px;" cellspacing="0" cellpadding="0">
            <tr>
                <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkNyilatkozat" /></td>
                <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:16px; line-height:21px; color:#222;" v-html="chk_nyilatkozat">
                    
                </td>
            </tr>
            </table>


            <div style="width:100%; box-sizing:border-box; text-align:center;">

                <span class="cms_linkbutton cms_linkbutton_2" style="margin: 4px 8px;" @click="Fizetes">
                    <span><i class="fal fa-check" style="margin-right:10px;"></i>Rendben</span>
                </span>

                <span class="cms_linkbutton cms_linkbutton_CANCEL" style="margin: 4px 8px;" @click="btnMegsem_click">
                    <span><i class="fal fa-times" style="margin-right:10px;"></i>Mégsem</span>
                </span>

            </div>   

        </div>


        <div style="width:100%; box-sizing:border-box; margin:10px 0px 0px 0px; display:block;" v-show="formid==4">

            <div style="width:100%; box-sizing:border-box; display:inline-block; text-align:center; font-weight:500; margin-bottom:26px; font-size:22px; line-height:22px; color:var(--themecolor3);">
                <i class="fal fa-credit-card-front" style="margin-right:10px;"></i>Bankkártyás befizetés
            </div>

            <div style="width:100%; box-sizing:border-box; display:inline-block;" v-html="sikeres_text">
            </div>
            
        </div>



        

    </div>
</template>

<script>

import GrcText from '../GrcComponents/GrcText.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDialogPayment_SimpleV2 from '../GrcComponents/GrcDialogPayment_SimpleV2.vue'
import CalcPopup from '../GrcComponents/CalcPopup.vue'

export default {
  name: 'frmbefizetes',
  components: {
      GrcDB,
      GrcDialog,
      GrcText,
      GrcNum,
      GrcDate,
      GrcCombo,
      GrcCheckboxMobile,
      GrcDialogPayment_SimpleV2,
      CalcPopup
  },
  props: {

  },
  data () {
      return {
          WSPREFIX: "frmBefizetes_",

          formid:0,

          txtTagkodSzemelyes:0,
          txtSzulDatum:"",

          txtTagkod:0,   
          txtJelszo:"",

          txtOsszeg:0,

          pTagkod:0,
          pNev:"",
          pSzulDatum:"",
          pEmailCim:"",

          TipusID:0,

          chk_nyilatkozat:"",

          SimpleTXID:"",
          SimpleUrl:"",
          OrderRef:"",

          sikeres_text:"",

          Calc_BelepesiDij:0,
          Calc_FedSzazalek: 0.00


      }
  },
  model: {

  },  
  methods:{

    Calc_Show()
    {
        this.$refs.CalcPopup.Show(
            this.Calc_BelepesiDij,
            this.Calc_FedSzazalek
        );
    },

    Calc_SetValue(pOsszeg)
    {
        this.$refs.txtOsszeg.SetValue(pOsszeg);
    },

    GoToForm(pFormID)
    {
        this.$refs.txtJelszo.SetText("");
        this.formid = pFormID;
    },

    async Fizetes()
    {
        if (this.$refs.cboTipus.GetValue() < 1)
        {
            gApp.HandleCommError("Kérjük válassza ki a befizetés típusát!");
            return;
        }

        if (this.$refs.txtOsszeg.GetValue() < 1)
        {
            gApp.HandleCommError("Az összeg megadása kötelező!");
            return;
        }

        if (this.$refs.txtEmailCim.GetText().trim() == "")
        {
            gApp.HandleCommError("Az értesítési e-mail cím megadása kötelező!");
            return;
        }

        if (grcmain_IsValidEmailAddress(this.$refs.txtEmailCim.GetText()) == false)
        {
            gApp.HandleCommError("Az értesítési e-mail cím helytelen!");
            return;
        }

        if (this.$refs.chkNyilatkozat.GetValue() == 0)
        {
            gApp.HandleCommError("A nyilatkozat elfogadása kötelező!");
            return;
        }


        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sIPAddress: "[IPADDRESS]",
            iTagkod:this.pTagkod,
            sNev:this.pNev,
            sSzulDatum:this.pSzulDatum,
            sEmailCim:this.$refs.txtEmailCim.GetText().trim(),
            iOsszeg:this.$refs.txtOsszeg.GetValue(),
            iTipusID: this.$refs.cboTipus.GetValue()

        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Fizetes", QP).then(res => { Q = res; });


        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        document.location = Q.RESULT[0].SimpleUrl;

        /*
        this.SimpleTXID = Q.RESULT[0].SimpleTXID;
        this.SimpleUrl = Q.RESULT[0].SimpleUrl;
        this.OrderRef = Q.RESULT[0].OrderRef;

        this.SimpleFizetes();
        */

    },

    async SimpleFizetes()
    {
        let Q ={ PAYMENT:[{SimpleUrl:this.SimpleUrl, ORDER_REF:this.OrderRef}] };

        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults("", "");             
        p.height = 1000;
        p.width = 1000;
        p.padding_top = -1;
        p.title = "<i class='fal fa-credit-card' style='margin-right:6px;'></i>" + "Bankkártyás befizetés";
        await this.$refs.DialogPayment.ShowDialog(p, Q).then(res => 
        { 
            DialogResult = res; 
        });       

        // if (DialogResult == 3) // backref ágra ment, ellenőrizni az eredményt


        this.$refs.GRCDB.ShowLoading(false);

        var QP2 = {
            sOrderRef: this.OrderRef
        };
        
        var Q2;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "CheckResult", QP2).then(res => { Q2 = res; });


        if (Q2.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q2.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        if (Q2.RESULT[0].intResult == 1)
        {
            let s = this.GetTextBookItem("sikeres_text");
            s = s.replaceAll("[SIMPLETXID]", this.SimpleTXID);
            s = s.replaceAll("[ORDERREF]", this.OrderRef);
            s = s.replaceAll("[OSSZEG]", Q2.RESULT[0].Osszeg);

            this.sikeres_text = s;
            
            this.formid = 4;
        }

    },


    async Azonositas(pVersion)
    {
        let pTagkod = 0;
        let pNev = "";
        let pSzulDatum = "";
        let pJelszo = "";

        if (pVersion == 1)
        {
            if ((this.$refs.txtTagkod.GetValue() < 1) || (this.$refs.txtJelszo.GetText().trim() == ""))
            {
                gApp.HandleCommError("A tagkód és jelszó megadása kötelező!");
                return;
            }

            pTagkod = this.$refs.txtTagkod.GetValue();
            pJelszo = this.$refs.txtJelszo.GetText().trim();
        }

        if (pVersion == 2)
        {
            if ((this.$refs.txtTagkodSzemelyes.GetValue() < 1) || (this.$refs.txtNev.GetText().trim() == "") || (this.$refs.txtSzulDatum.IsValid(false)==false))
            {
                gApp.HandleCommError("A mezők megadása hiányos vagy helytelen!");
                return;
            }

            pTagkod = this.$refs.txtTagkodSzemelyes.GetValue();
            pNev = this.$refs.txtNev.GetText().trim();
            pSzulDatum = this.$refs.txtSzulDatum.GetText();
        }

        


        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sIPAddress: "[IPADDRESS]",
            iVersion:pVersion,
            iTagkod:pTagkod,
            sJelszo:pJelszo,
            sNev:pNev,
            sSzulDatum:pSzulDatum

        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Azonositas", QP).then(res => { Q = res; });


        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();


        if (Q.TAGADAT[0].Tagkod > 0)
        {
            this.pTagkod = Q.TAGADAT[0].Tagkod;
            this.pNev = Q.TAGADAT[0].Nev;
            this.pSzulDatum = Q.TAGADAT[0].SzulDatum;
            this.pEmailCim = Q.TAGADAT[0].EmailCim;

            this.Calc_BelepesiDij = Q.TAGADAT[0].Calc_BelepesiDij;
            this.Calc_FedSzazalek = Q.TAGADAT[0].Calc_FedSzazalek;


            this.$refs.txtEmailCim.SetText(Q.TAGADAT[0].EmailCim);

            this.formid = 3;

            return;
        }
        
    },


    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },


    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmBefizetes", pCompName);
    },

    SetLang()
    {
        this.chk_nyilatkozat = this.GetTextBookItem("chk_nyilatkozat");

        this.HideErrors();
        this.Init();
    },


      SetControlToFocus(pNextComp)
      {
        if (pNextComp == "") { return; }
        this.$refs[pNextComp].SetFocus();
      },

      btnOK_click(e)
      {
        this.Mentes();
      },

      btnMegsem_click(e)
      {
        document.location = "dashboard";
      },

      HideErrors()
      {
        this.$refs.txtEmailCim.HideError();
      },


      async Init()
      {
        let pOsszeg = 0;
        if ("OSSZEG" in GRCAPP_GetParameters) {
            pOsszeg = parseInt(GRCAPP_GetParameters.OSSZEG, 10);
        }
        if ("osszeg" in GRCAPP_GetParameters) {
            pOsszeg = parseInt(GRCAPP_GetParameters.osszeg, 10);
        }

        if (isNaN(pOsszeg)) {
            pOsszeg = 0;
        }


        this.$refs.txtOsszeg.SetValue(pOsszeg);


        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });


        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.$refs.cboTipus.SetDataSource(Q.TIPUSOK);

        let pTipusID = 0;
        if ("TIPUSID" in GRCAPP_GetParameters) {
            pTipusID = parseInt(GRCAPP_GetParameters.TIPUSID, 10);
        }
        if ("tipusid" in GRCAPP_GetParameters) {
            pTipusID = parseInt(GRCAPP_GetParameters.tipusid, 10);
        }

        if (isNaN(pTipusID)) {
            pTipusID = 0;
        }

        if ((pTipusID < 0)||(pTipusID>3)) { pTipusID = 0; }


        this.$refs.cboTipus.SetValue(pTipusID);


        if (Q.TAGADAT[0].Tagkod > 0)
        {
            this.pTagkod = Q.TAGADAT[0].Tagkod;
            this.pNev = Q.TAGADAT[0].Nev;
            this.pSzulDatum = Q.TAGADAT[0].SzulDatum;
            this.pEmailCim = Q.TAGADAT[0].EmailCim;

            this.$refs.txtEmailCim.SetText(Q.TAGADAT[0].EmailCim);

            this.Calc_BelepesiDij = Q.TAGADAT[0].Calc_BelepesiDij;
            this.Calc_FedSzazalek = Q.TAGADAT[0].Calc_FedSzazalek;


            this.formid = 3;

            return;
        }

        this.formid = 1;

      },



    async ShowInfo(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },





  },
  created()
  {

  },
  mounted()
  {
    this.SetLang();
  }

}


</script>


<style scoped>




</style>